import React from 'react';

interface Props {
  onClick?: () => void;
  style?: React.CSSProperties;
}
function BackButtonSVG(props: Props) {
  const {onClick, style} = props;
  return (
    <button
      onClick={onClick}
      aria-label="Back"
      style={{
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        padding: 0,
        ...style,
      }}
    >
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            d="M22.6815 11.5331H4.25088C5.24997 10.516 6.99546 8.83444 9.16281 6.95094L8.24764 5.96094C8.18578 6.01464 2.0625 11.3447 2.0625 12.1982C2.0625 13.0751 8.1863 18.4345 8.24764 18.4882L9.16281 17.4982C6.99278 15.6129 5.23234 13.8975 4.23274 12.8634H22.6815V11.5331Z"
            fill="white"
          />
        </g>
      </svg>
    </button>
  );
}

export default BackButtonSVG;
